import { render } from "./base-dialog-card_confirmation.vue?vue&type=template&id=07fe0d71&ts=true"
import script from "./base-dialog-card_confirmation.vue?vue&type=script&lang=ts"
export * from "./base-dialog-card_confirmation.vue?vue&type=script&lang=ts"

import "./base-dialog-card_confirmation.vue?vue&type=style&index=0&id=07fe0d71&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__